(() => {
  const init = () => {
    const root = document.getElementById('rmbrand511');
    if (!root) return;
    const q = s => root.querySelector(s), qa = s => [...root.querySelectorAll(s)];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const filter = key => {
      qa('[data-filter]').forEach(b => {
        const active=b.dataset.filter===key;
        b.classList.toggle('rb-active',active);b.setAttribute('aria-pressed',String(active));
      });
      qa('[data-product-category]').forEach(p => {
        p.hidden=key==='all'?p.dataset.featured!=='true':p.dataset.productCategory!==key;
      });
    };
    const selectUse = key => {
      qa('[data-use]').forEach(b=>{
        const active=b.dataset.use===key;b.setAttribute('aria-selected',String(active));b.tabIndex=active?0:-1;
      });
      qa('.rb-use-panel').forEach(p=>{p.hidden=p.id!=='panel-'+key;});
    };
    qa('[data-filter]').forEach(b=>{b.onclick=()=>filter(b.dataset.filter);});
    qa('[data-category]').forEach(b=>{b.onclick=()=>filter(b.dataset.category);});
    qa('[data-filter-target]').forEach(b=>{b.onclick=()=>filter(b.dataset.filterTarget);});
    qa('[data-use]').forEach(b=>{
      b.onclick=()=>selectUse(b.dataset.use);
      b.onkeydown=e=>{
        const tabs=qa('[data-use]');let i=tabs.indexOf(b);
        if(e.key==='ArrowRight')i=(i+1)%tabs.length;
        else if(e.key==='ArrowLeft')i=(i+tabs.length-1)%tabs.length;
        else if(e.key==='Home')i=0;
        else if(e.key==='End')i=tabs.length-1;
        else return;
        e.preventDefault();tabs[i].focus();selectUse(tabs[i].dataset.use);
      };
    });
    filter('all');
    const video=q('#brand-video'),button=q('.rb-video-toggle');
    const state=()=>{
      if(!video||!button)return;
      button.setAttribute('aria-pressed',String(video.paused));
      button.setAttribute('aria-label',video.paused?'Spela filmen':'Pausa filmen');
      button.textContent=video.paused?'▷ Spela film':'Ⅱ Pausa film';
    };
    if(video&&button){
      video.onplay=state;video.onpause=state;
      button.onclick=()=>{if(video.paused)video.play().catch(()=>{});else video.pause();};
      if(reduced.matches)video.pause();
      state();
    }
    const marquee=q('.rb-marquee'),motion=q('#motion-toggle');
    const motionState=()=>{
      if(!marquee||!motion)return;
      const paused=marquee.classList.contains('rb-paused');
      motion.setAttribute('aria-pressed',String(paused));
      motion.setAttribute('aria-label',paused?'Starta rullande text':'Pausa rullande text');
      motion.textContent=paused?'▷':'Ⅱ';
    };
    if(marquee&&motion){
      if(reduced.matches)marquee.classList.add('rb-paused');
      motion.onclick=()=>{marquee.classList.toggle('rb-paused');motionState();};
      motionState();
    }
    qa('.rb-questions details').forEach(el=>{
      el.querySelector('summary').onclick=e=>{
        e.preventDefault();const open=!el.open;
        qa('.rb-questions details').forEach(other=>{other.open=false;});el.open=open;
      };
    });
    // Content stays visible in the editor and when JS or IntersectionObserver fails.
    if(!window.Shopify?.designMode&&!reduced.matches&&'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(e=>{
        if(e.isIntersecting){e.target.classList.remove('rb-pending');observer.unobserve(e.target);}
      }),{threshold:.12});
      qa('.rb-reveal').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight)el.classList.add('rb-pending');observer.observe(el);});
    }
    const progress=()=>{
      const bar=q('.rb-progress');if(!bar)return;
      const max=document.documentElement.scrollHeight-innerHeight;
      bar.style.transform=`scaleX(${max>0?Math.min(1,scrollY/max):0})`;
    };
    if(root._scrollHandler)removeEventListener('scroll',root._scrollHandler);
    root._scrollHandler=progress;addEventListener('scroll',progress,{passive:true});progress();
    if(root._motionHandler)root._motionQuery.removeEventListener('change',root._motionHandler);
    root._motionQuery=reduced;
    root._motionHandler=()=>{if(reduced.matches){video?.pause();marquee?.classList.add('rb-paused');qa('.rb-pending').forEach(el=>el.classList.remove('rb-pending'));}state();motionState();};
    reduced.addEventListener('change',root._motionHandler);
  };
  init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
  document.addEventListener('shopify:block:select',e=>{
    const panel=e.target.closest?.('.rb-use-panel');
    if(panel)document.querySelector(`[data-use="${panel.id.replace('panel-','')}"]`)?.click();
    const card=e.target.closest?.('[data-product-category]');
    if(card)document.querySelector(`[data-filter="${card.dataset.productCategory}"]`)?.click();
  });
})();
